import { render, staticRenderFns } from "./OnboardingShareAccessModal.vue?vue&type=template&id=6060841d&scoped=true"
import script from "./OnboardingShareAccessModal.vue?vue&type=script&lang=js"
export * from "./OnboardingShareAccessModal.vue?vue&type=script&lang=js"
import style0 from "./OnboardingShareAccessModal.vue?vue&type=style&index=0&id=6060841d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6060841d",
  null
  
)

export default component.exports